import constate from 'constate';
import { useImmer } from 'use-immer';

export enum WebAppVersion {
  /** 内部使用的可外网访问版本（internal.bugly.qq.com） */
  Internal = 'internal',
  /** woa纯内网版本（bugly.woa.com） */
  WOA = 'woa',
}

export interface GlobalConfig {
  appVersion: WebAppVersion
}

/**
 * 全局context
 */
const useGlobalConfig = () => {
  const [config, setConfig] = useImmer<GlobalConfig>({
    appVersion: process.env.APP_VERSION as WebAppVersion,
  });

  const updateConfig = (path: keyof GlobalConfig, value: any) => {
    setConfig((draft) => {
      // eslint-disable-next-line no-param-reassign
      draft[path] = value;
    });
  };

  return { config, updateConfig };
};


const [GlobalConfigProvider, useGlobalConfigContext] = constate(useGlobalConfig);

export {
  GlobalConfigProvider,
  useGlobalConfigContext,
};
